import styled from 'styled-components';
import { styledComponentProps } from '../../types/theme';
import { BodyBoldXs } from '../../styles/common/typo.styles';
import {theme} from "../../styles/theme";

export const Card = styled.a<any>`
	height: 253px;
	box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
	background-color: #ffffff;
	margin: 24px 0;
	display: flex;
	position: relative;
	font-family: 'FedraSansBarilan', 'Roboto', '"Helvetica Neue"', 'Arial',
		'sans-serif', '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"';

	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.lg} {
		flex-direction: column;
		align-items: flex-end;
		height: max-content;
	}
`;

export const Banner = styled.img`
	width: 100%;
	min-width: 382px;
	background-color: rgba(0, 0, 0, 0.2);
	object-fit: cover;
	cursor: pointer;

	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.lg} {
		min-width: 300px;
	}

	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.md} {
		min-width: 250px;
	}
	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.sm} {
		height: 211px;
		width: 100%;
	}
	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.xs} {
		height: 211px;
		min-width: 300px;
	}
`;

export const Details = styled.div`
	display: flex;
	padding: 24px;
	cursor: pointer;
	padding-right: ${({ theme }: styledComponentProps): number =>
		theme.layout.dir === 'ltr' ? 0 : 24}px;
	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.lg} {
		padding: 20px;
		padding-right: ${({ theme }: styledComponentProps): number =>
			theme.layout.dir === 'ltr' ? 0 : 20}px;
		width: 100%;
	}
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	width: 380px;
	padding: 0 8px;
	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.lg} {
		width: 180px;
	}
	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.md} {
		width: 130px;
	}
	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.sm} {
		width: 100%;
		padding: 0;
	}
`;

export const Separator = styled.div`
	height: 202px;
	width: 1px;
	margin: 0 24px;
	background-color: #033535;
	opacity: 0.5;

	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.lg} {
		display: none;
	}
`;

export const DateView = styled.div`
	min-width: 120px;
	height: 70px;
	padding: 20px 10px;
	background-color: #78cde6;
	position: absolute;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	top: 26px;
	${({ theme }: styledComponentProps): string =>
		theme.layout.dir === 'rtl' ? 'right' : 'left'}: ${({ theme }: styledComponentProps) =>
		theme.layout.dir === 'rtl' ? '-20px' : '-20px'};
	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.xl} {
		${({ theme }: styledComponentProps): string =>
			theme.layout.dir === 'rtl' ? 'right' : 'left'}: 0;
	}
`;

export const DateViewTwo = styled.div`
	height: 70px;
	display: flex;
	flex-direction: row;
	justify-content: space-evenly;
	align-items: center;
	${({ theme }: styledComponentProps): string =>
		theme.layout.dir === 'rtl' ? 'right' : 'left'}: ${({ theme }: styledComponentProps) =>
		theme.layout.dir === 'rtl' ? '-10px' : '-10px'};
`;

export const DateViewCol = styled.div`
	height: 70px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	${({ theme }: styledComponentProps): string =>
	theme.layout.dir === 'ltr' ? 'right' : 'left'}: 95%;

	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.md} {
		${({ theme }: styledComponentProps): string =>
	theme.layout.dir === 'ltr' ? 'right' : 'left'}: 90%;
	}
	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.sm} {
		${({ theme }: styledComponentProps): string =>
	theme.layout.dir === 'ltr' ? 'right' : 'left'}: 80%;
	}
`;

export const Highlighter = styled.div`
	padding: 12px 24px;
	background-color: #78cde6;
	position: absolute;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	top: 26px;
	width: max-content;
	${({ theme }: styledComponentProps): string =>
		theme.layout.dir === 'rtl' ? 'left' : 'right'}: ${({ theme }: styledComponentProps) =>
		theme.layout.dir === 'rtl' ? '-20px' : '-20px'};
	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.xl} {
		${({ theme }: styledComponentProps): string =>
			theme.layout.dir === 'rtl' ? 'left' : 'right'}: 0;
	}
`;

export const ActionView = styled.div`
	position: relative;
	padding: 72px
		${({ theme }: styledComponentProps): number =>
			theme.layout.dir === 'ltr' ? 24 : 0}px
		0px
		${({ theme }: styledComponentProps): number =>
			theme.layout.dir === 'ltr' ? 0 : 24}px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;

	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.xl} {
		padding: 72px 0px 0px 16px;
	}
	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.lg} {
		padding: 20px;
	}
`;

export const TypeView = styled.div`
	display: flex;
	align-items: center;
`;

export const LeftArrow = styled.img<any>`
	position: absolute;
	bottom: 1.5rem;
	transition: 0.2s all ease-in;
	${({ direction, hover }: styledComponentProps): string => {
		return direction === 'rtl'
			? `left: ${hover ? 1.5 : 2.5}rem;`
			: `right: ${hover ? 1.5 : 2.5}rem; transform: rotate(180deg);`;
	}}
`;

export const TextDivider = styled(BodyBoldXs)`
	padding: 0 0.25rem;
`;